import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { TipoPagoService } from 'src/app/services/tipo-pago.service';
import { DatesService } from "src/app/shared/services/dates.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ControlEfectivoService } from 'src/app/services/control-efectivo.service';
import * as _ from "lodash";
import { RutService } from "src/app/shared/services/rut.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";

@Component({
  selector: 'app-caja-diaria-modal-detalle',
  templateUrl: './modal-detalle.component.html',
  styleUrls: ['./modal-detalle.component.scss'],
  providers: [SecurityService],
})
export class CajaDiariaModalDetalleComponent implements OnInit {

  // Modales
  @ViewChild('detalleCajaDiaria', { static: true }) modalDetalleCajaDiaria: ModalDirective;

  @Output() onDetalle: EventEmitter<any> = new EventEmitter()

  // Form
  formData: FormGroup

  // Data &  Tmp
  optionsTipoPago: Array<any> = [];
  optionsItem: Array<any> = [];
  isEditing: boolean = false
  codigoEditado = 0
  private rutEmpresa: number
  private sucursalCodigo: number
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  private currentPayload: any = null
  listaMovimientosAll: Array<any> = null
  listaMovimientos: Array<any> = null

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private tipoPagoService: TipoPagoService,
    private datesService: DatesService,
    private accesolocalstorage: SecurityService,
    private ControlEfectivoService: ControlEfectivoService,
    private rutService: RutService,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('DETALLE DE CAJA DIARIA')
   }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10
    this.createForm()
    this.optionsItem = [
        { value: "1", label: "Recaudación en Recorrido" },
        { value: "2", label: "Recaudación Fuera de Recorrido" },
        { value: "3", label: "Recaudación por Caja" },
        { value: "4", label: "Recaudación Total" },
      ];
    this.loadTipoPago()
  }

  private loadTipoPago() {
    // Tipos documentos
    this.tipoPagoService.GetByTipoPago(({ respuesta }) => {
      const { registros } = respuesta
      this.optionsTipoPago = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
      //this.setDefaultDoctoReferencia()
    })
  }

  private createForm() {
    //const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      fechaDetalle: [[Validators.required]],
      recaudacion: ['', [Validators.required]],
      listaTipoPago: [[]],
    });
  }

  show() {
    this.isEditing = false
    this.clearData()
    this.modalDetalleCajaDiaria.show()
  }

  hide() {
    this.modalDetalleCajaDiaria.hide()
  }

  load(fechaCaja) {
    this.isEditing = true
    //this.codigoEditado = familia.codigo
    this.clearData()
    this.formData.get('fechaDetalle').setValue(fechaCaja)
    // this.formData.get('nombre').setValue(familia.nombre)
    // this.formData.get('rubro').setValue(familia.rubro_codigo)
    this.modalDetalleCajaDiaria.show()
  }

  clearData() {
    this.formValidatorsService.reset(this.formData)
  }

  buscar(pageNumber: number) {
    this.log('inputParams', JSON.stringify(this.formData.get('fechaDetalle').value))

    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid) {
      this.toastrService.error('Debe seleccionar Recaudacíon')
      return
    }

    this.paginationContext.CurrentPage = pageNumber

    //this.listaMovimientos = []
    //this.listaMovimientosAll = []

    const { fechaDetalle, recaudacion, listaTipoPago } = this.formData.value
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_declaracion: fechaDetalle,
        listaTipoPago: listaTipoPago,
        resumen: recaudacion,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams
    //this.docSeleccionado = 0
    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.listaMovimientos = null
    this.listaMovimientosAll = null

    this.ControlEfectivoService.GetByDetalleCajaDiaria(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta
      this.listaMovimientosAll = registros
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {}
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
        mov.additionalInfo.index = index
      })

      this.showPage(this.paginationContext.CurrentPage)
      this.loading = false
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  documentoDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'
    inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.ControlEfectivoService.GetByDetalleCajaDiariaExcelPDF(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
}

